import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  MODAL_SIZE_SM,
  Modal,
  ModalBody,
  ModalHead,
  ModalFoot,
  Button,
  Checkbox
} from 'mailup-web-components'
import styled from '@emotion/styled'
import { modalConfirmEnableNotificationState } from 'Pages/MessageEdit/recoil/state/modals'
import {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME
} from 'Constants/index'
import { enableNotificationCallback } from 'Pages/MessageEdit/recoil/callbacks/callbacks'

export const ModalConfirmEnableNotification = () => {
  const intl = useIntl()
  const { show, requiresUpdateWelcomeSeries, messageType } = useRecoilValue(
    modalConfirmEnableNotificationState
  )
  const setShow = useSetRecoilState(modalConfirmEnableNotificationState)

  const [checked, setChecked] = useState(false)
  const enableNotification = useRecoilCallback(enableNotificationCallback, [])

  const handleClick = () => enableNotification(checked)

  const handleCheck = () => setChecked(!checked)
  const handleClose = () => setShow(prev => ({ ...prev, show: false }))

  const modalHeadTitleId =
    messageType === MESSAGE_STR_TYPE_CONFIRMATION
      ? 'Load.SaveEmailWizard.ModalMessageTitleConfirmationEmail'
      : 'Load.SavedEmailWizard.WelcomeMessage'

  const modalBodyId =
    messageType === MESSAGE_STR_TYPE_CONFIRMATION
      ? 'Load.SaveEmailWizard.ModalMessageDescription'
      : requiresUpdateWelcomeSeries && messageType === MESSAGE_STR_TYPE_WELCOME
      ? 'Load.SavedEmailWizard.ModalMessageActiveDescrWelcomeSeriesNew'
      : 'Load.SavedEmailWizard.ModalMessageActiveWelcomeDescr'

  return (
    <Modal
      data-mu-test='modal-confirm-leave'
      show={show}
      size={MODAL_SIZE_SM}
      onClose={handleClose}
    >
      <ModalHead
        title={intl.formatMessage({
          id: modalHeadTitleId
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: modalBodyId
        })}
      </ModalBody>
      <ModalFoot>
        <CheckBoxContainer>
          <StyledCheckbox
            kind='neutral'
            checked={checked}
            value={checked}
            onChange={handleCheck}
            label={intl.formatMessage({
              id: 'Load.EmailMessageList.PutAsDefault'
            })}
            data-mu-test='button-cancel'
          />
        </CheckBoxContainer>
        <StyledButton
          kind='primary'
          onClick={handleClick}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </StyledButton>
      </ModalFoot>
    </Modal>
  )
}

const CheckBoxContainer = styled.div`
  height: 36px;
  color: #16a7cd;
  border: 1px solid #16a7cd;
  border-radius: 4px 0px 0px 4px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  padding: 10px 16px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    text-decoration: none;
    cursor: pointer;
    background-color: transparent;
    color: #1286a4;
    border-color: #1286a4;
    outline: 0;
  }
`

const StyledCheckbox = styled(Checkbox)`
  .c-checkbox__label {
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
`

const StyledButton = styled(Button)`
  margin-left: 0 !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`
